import { AccessTime, DateRange } from '@mui/icons-material';
import { Box, Chip, Typography } from '@mui/material';
import { theme } from 'theme/theme';
import { IPropValor } from 'utils/models/interfaces';
import { TallerBase } from 'utils/models/types';
import { convertirFechasStringAFechas, convertirFechasAHorarios, formatearFechaParaListado } from 'utils/utilities';

const InformacionTaller = ({ taller }: { taller: TallerBase }) => {
  const datosTaller: IPropValor[] = [
    {
      propiedad: 'Sala',
      valor: taller.NombreSala,
    },
    {
      propiedad: 'Docente',
      valor: taller.Docente,
    },
    {
      propiedad: 'Valor cuota',
      valor: `$${taller.ValorCuota}`,
    },
  ];

  const horariosClasesEnDate =
    taller.HorariosClases && taller.HorariosClases.map(fecha => convertirFechasStringAFechas(fecha));
  const horariosFormateados = convertirFechasAHorarios(horariosClasesEnDate);
  const fechaInicio =
    taller.HorariosClases && formatearFechaParaListado(taller.HorariosClases[0]?.FechaInicio.toString());
  const fechaFin =
    taller.HorariosClases &&
    formatearFechaParaListado(taller.HorariosClases[taller.HorariosClases.length - 1]?.FechaInicio.toString());

  return (
    <Box
      className="hola"
      flex="1"
      maxHeight="500px"
      maxWidth={{ xs: 'unset', sm: '400px', md: '400px' }}
      mx="auto"
      boxSizing="border-box"
      sx={{
        border: `1px solid ${theme.palette.secondary.main}`,
        backgroundColor: 'white',
        p: { xs: 2, md: 4 },
        borderRadius: 4,
        overflowY: 'auto',
      }}
    >
      <Box sx={{ backgroundColor: theme.palette.primary.main, color: 'white' }} p={3} borderRadius={4}>
        <Typography variant="body1" mb={2} color={theme.palette.secondary.main}>
          <b>Programa</b>
        </Typography>
        <Typography variant="body1">
          <i>{taller.Programa}</i>
        </Typography>

        <Box display="flex" gap={2} justifyContent="center" alignItems="end">
          <Box>
            <Typography variant="body2" mt={1} color={theme.palette.secondary.main}>
              <b>Fecha de inicio</b>
            </Typography>
            <Chip
              variant="outlined"
              size="medium"
              sx={{ mt: 1, color: 'white' }}
              label={fechaInicio}
              icon={<DateRange sx={{ fontSize: '1rem' }} />}
            />
          </Box>
          <Box>
            <Typography variant="body2" mt={1} color={theme.palette.secondary.main}>
              <b>Fecha de fin</b>
            </Typography>
            <Chip
              variant="outlined"
              size="medium"
              sx={{ mt: 1, color: 'white' }}
              label={fechaFin}
              icon={<DateRange sx={{ fontSize: '1rem' }} />}
            />
          </Box>
        </Box>
        <Typography variant="body2" mt={1} color={theme.palette.secondary.main}>
          <b>Horario</b>
        </Typography>
        <Chip
          variant="outlined"
          size="medium"
          sx={{ mt: 1, color: 'white' }}
          label={`${horariosFormateados} hs.`}
          icon={<AccessTime sx={{ fontSize: '1rem', color: 'white' }} />}
        />
      </Box>

      <Box mt={4}>
        {datosTaller.map(
          ({ propiedad, valor }) =>
            valor && (
              <Box display="flex" gap={3} justifyContent="space-between" key={`${propiedad}${valor}`}>
                <Typography variant="body1" color={theme.palette.secondary.main}>
                  <b>{propiedad}</b>
                </Typography>
                <Typography variant="body1" color={theme.palette.primary.main}>
                  {valor}
                </Typography>
              </Box>
            )
        )}
      </Box>
    </Box>
  );
};

export default InformacionTaller;
